import { render, staticRenderFns } from "./TrialStart.vue?vue&type=template&id=8835261c&scoped=true"
import script from "./TrialStart.vue?vue&type=script&lang=js"
export * from "./TrialStart.vue?vue&type=script&lang=js"
import style0 from "./TrialStart.vue?vue&type=style&index=0&id=8835261c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8835261c",
  null
  
)

export default component.exports